import { Component, OnInit } from '@angular/core';
import {TrustPayTransaction} from '../../../dto/trustPayTransaction';
import {TrustPayService} from '../../../trust-pay.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Customer} from '../../../dto/customer';
import {DatePipe, Location} from '@angular/common';
import {CardSearch} from '../../../dto/card-search';
import {RoleService} from '../../../services/role.service';
import {PrevNextModel} from '../../../models/prev-next-model';
import {getTableFilters} from '../../../helpers/storage-helper';

@Component({
  selector: 'app-transaction-view',
  templateUrl: './transaction-view.component.html',
  styleUrls: ['./transaction-view.component.css']
})
export class TransactionViewComponent implements OnInit {
  transaction: TrustPayTransaction;
  private transactionId: number|null;
  fields = [
    { header: 'Date', cell: (row: TrustPayTransaction) => `${this.datePipe.transform(row.createDate, 'dd.MM.yyyy')}` },
    { header: 'Source', cell: (row: TrustPayTransaction) => {
      if ( row.source === 1 ) {
        return 'Trustpay';
      }
      if ( row.source === 0) {
        return 'Revolut';
      }
      if ( row.source === 2) {
        return 'Qonto';
      }
      if ( row.source === 3) {
        return 'Commerzbank';
      }
      if ( row.source === 4) {
        return 'MIcropayment';
      }
    }},
    { header: 'Amount', cell: (row: TrustPayTransaction) => `${row.amount.formatMoneyEuro() || ''}` },
    { header: 'Reference', cell: (row: TrustPayTransaction) => `${row.reference || ''}` },
    { header: 'Description', cell: (row: TrustPayTransaction) => `${row.description || ''}` },
    { header: 'Counter Account', cell: (row: TrustPayTransaction) => `${row.counterAccountMasked || ''}` },
    { header: 'Counter Account Name', cell: (row: TrustPayTransaction) => `${row.counterAccountName || ''}` },
  ];

  constructor(
    private trustPayService: TrustPayService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private location: Location,
    private roleService: RoleService,
    private router: Router,
  ) { }

  currentUserIsAdmin(): boolean {
    return this.roleService.hasRoles('admin');
  }
  currentUserIsSuperAdmin(): boolean {
    return this.roleService.hasRoles( 'super_admin' );
  }


  isBusy = false;
  prevNext: PrevNextModel;

  cards1Found: CardSearch[] = [];
  cardSearch1Loading = false;
  cardSearch1: string = null;
  isLoading = false;
  onSearchCard1() {
    if (this.cardSearch1 == null || (this.cardSearch1.length <= 3)) {
      return;
    }

    this.cards1Found = null;
    this.cardSearch1Loading = true;
    this.trustPayService.searchCards(this.cardSearch1).subscribe(result => {
      if ( result != null && result.length > 0 ) {
        this.cards1Found = result;
      }
      this.cardSearch1Loading = false;
    });
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {

      this.transaction = null;

      const id = parseInt(this.route.snapshot.paramMap.get('id'));
      this.transactionId = id;

      this.loadTrustPayTransaction(id);
      this.getPrevNext(this.transactionId);

    });
  }

  private loadTrustPayTransaction(id: number) {
    this.trustPayService.get(id).subscribe(data => {
      this.transaction = data;
    });
  }

  linkCard(cardId: number) {

    this.isBusy = true;

    this.trustPayService.linkTransactionToCard(this.transactionId, cardId).subscribe(result => {
      this.refreshData();
      this.isBusy = false;
    });
  }

  refundTransaction() {

    this.isBusy = true;

    this.trustPayService.refundTransaction(this.transactionId).subscribe(result => {
      this.refreshData();
      this.isBusy = false;
    });
  }

  refreshData(){
    this.trustPayService.get(this.transactionId).subscribe( result => {
      this.transaction = result;
    });

    this.getPrevNext(this.transactionId);

  }

  returnBack() {
    this.router.navigate(['../..'], { relativeTo: this.route });
  }

  unlinkCard(cardId: number) {
    this.isBusy = true;
    this.trustPayService.unlinkTransactionFromCard(this.transactionId, cardId).subscribe(result => {
      this.refreshData();
      this.isBusy = false;
    });
  }




  getNotLinkedTableFilters() {
    return getTableFilters('trustPayTransactionTable');
  }

  getPrevNext(id: number) {
    const filters = this.getNotLinkedTableFilters();
    //console.log(filters);
    this.trustPayService.getPrevNext(filters, id).subscribe(result => {
      this.prevNext = result;
    });
  }

  gotoPrevTrans(){
    this.cards1Found = null;
    this.cardSearch1 = null;
    const filters = this.getNotLinkedTableFilters();
    this.trustPayService.getPrev(filters, this.transactionId).subscribe(result => {
      this.router.navigate(['/loads/btl/transaction/'+result]);
    });

  }

  gotoNextTrans(){
    this.cards1Found = null;
    this.cardSearch1 = null;
    const filters = this.getNotLinkedTableFilters();
    this.trustPayService.getNext(filters, this.transactionId).subscribe(result => {
      this.router.navigate(['/loads/btl/transaction/'+result]);
    });
  }


  searchTransactionReference() {
    this.cardSearch1 = this.transaction.reference;
    this.onSearchCard1();
  }

  searchTransactionDescription() {
    this.cardSearch1 = this.transaction.description;
    this.onSearchCard1();
  }

  searchTransactionCounterAccountName() {
    this.cardSearch1 = this.transaction.counterAccountName;
    this.onSearchCard1();
  }

}
